import React from 'react'
import Select from '@/components/Select'
import type { SDUIComponentProps } from '@/types/sduiTypes'

interface SelectOption {
    label: string
    value: string | number
}

/**
 * SDUI Select adapter — wraps the existing Select (react-select) component
 * to conform to the SDUI component contract.
 */
const SDUISelect: React.FC<SDUIComponentProps> = ({
    id,
    label,
    value,
    errors,
    disabled,
    placeholder,
    options,
    isMulti,
    onChange,
}) => {
    const hasErrors = errors && errors.length > 0
    const selectOptions = (options as SelectOption[]) || []

    // Find current value object from options
    const currentValue = selectOptions.find((opt) => opt.value === value) || null

    const handleChange = (selected: SelectOption | null) => {
        onChange?.(selected?.value ?? null)
    }

    return (
        <div className="w-full">
            {label && (
                <label
                    htmlFor={id}
                    className="block font-medium text-gray-700 dark:text-gray-200 mb-1 text-sm"
                >
                    {label}
                </label>
            )}
            <Select<SelectOption>
                isClearable
                id={id}
                value={currentValue}
                options={selectOptions}
                isDisabled={disabled}
                isMulti={(isMulti as boolean) || false}
                placeholder={(placeholder as string) || 'Select...'}
                onChange={handleChange}
            />
            {hasErrors && (
                <div className="mt-1">
                    {errors.map((err, idx) => (
                        <p
                            key={`${id}-error-${idx}`}
                            className="text-red-500 text-xs"
                        >
                            {err}
                        </p>
                    ))}
                </div>
            )}
        </div>
    )
}

SDUISelect.displayName = 'SDUISelect'

export default SDUISelect
